module.exports = __webpack_public_path__ + "img/alert.58e0324e.png";